import React from "react";
import Timer from "./Timer";

const CustomerClub = (props) => {
  const { lottery_title, timer } = props;

  return (
    <div className={` ${"customerClub"}`}>
      <div className={"customerClubTimer"}>
        <div className={"customerTimerDetails"}>
          <div className={"customerTimer"}>
            <span className={"timerTitle"}>
              روزشمار برگزاری {lottery_title}
            </span>
            <Timer expireTime={timer.expire_time} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerClub;
